import { memo } from 'react';

import { Plus } from '@air/next-icons';
import { cn } from '@air/utils-tailwind';

import {
  PersonSelectItemBase,
  type PersonSelectItemBaseProps,
} from '~/components/AssetModal/shared/components/FacesPanel/components/PersonTextSelect/components/PersonSelectItemBase';

type CreateNewPersonSelectItemProps = Omit<PersonSelectItemBaseProps, 'prefix'>;

export const CreateNewPersonSelectItem = memo(({ className, ...props }: CreateNewPersonSelectItemProps) => (
  <PersonSelectItemBase
    data-testid="CREATE_NEW_PERSON"
    className={cn('font-semibold text-grey-10', className)}
    prefix={<Plus className="size-4" />}
    {...props}
  />
));

CreateNewPersonSelectItem.displayName = 'CreateNewPersonSelectItem';
